export default [
  {
    name: 'number_of_surveys',
    included: true,
  },
  {
    name: 'questions_per_survey',
    included: true,
  },
  {
    name: 'unlimited_responses',
    included: true,
  },
  {
    name: 'email_support',
    included: true,
  },
  {
    name: 'customization',
    included: true,
  },
  {
    name: 'data_exports',
    included: true,
  },
  {
    name: 'skip_logic',
    included: true,
  },
  {
    name: 'piping',
    included: true,
  },
  {
    name: 'file_upload',
    included: false,
  },
  {
    name: 'a_b_testing',
    included: true,
  },
  {
    name: 'hide_footer',
    included: true,
  },
  {
    name: 'multilingual',
    included: true,
  },
];
